import React, { useEffect, useState } from 'react';
import { Modal, Spinner, Button, Table } from 'react-bootstrap';
import { getSFTPLogDetailById } from '../../../../Redux/sftpClient/action';
import moment from 'moment';
import { Tooltip } from '@mui/material';
import { useRowLoaders } from '../../../../hooks/dataTableRowLoader';

const LogDetailsModal = ({ show, onClose, pk }) => {
  const [logData, setLogData] = useState(null);
  const [loading, setLoading] = useState(true);
  const { setLoading: rowLoader, isRowLoading, clearLoading } = useRowLoaders();
  const tableRef = React.useRef();
  const [reload,setReload] = useState(false)
  const [copied, setCopied] = useState(false);

  const handleCopyTableToClipboard = () => {
    if (!tableRef.current) return;

    let text = '';
    const rows = tableRef.current.querySelectorAll('tr');

    rows.forEach(row => {
      const cells = row.querySelectorAll('th, td');
      const rowText = Array.from(cells).map(cell => cell.textContent.trim()).join('\t');
      text += rowText + '\n';
    });

    navigator.clipboard.writeText(text).then(() => {
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    }).catch(() => {
      console.error('Failed to copy table.');
    });
  };
  useEffect(() => {
    if (!pk || !show) return;

    setLoading(true);
    getSFTPLogDetailById(pk)((res) => {
      if (res?.status && res?.data) {
        setLogData(res.data);
      } else {
        setLogData(null);
      }
      setLoading(false);
    });
  }, [pk,reload ,show ]);
  const formatLabel = (key) => {
    return key.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
  };

    // Add this helper function to format values
   const formatValue = (value) => {
     if (value === null || value === undefined) {
       return '—';
     }

     // If it's an object (but not array), format it as readable JSON
     if (typeof value === 'object' && !Array.isArray(value)) {
       try {
         return JSON.stringify(value, null, 2); // Pretty print with 2-space indentation
       } catch (error) {
         return String(value);
       }
     }

     // If it's an array, format it as readable array
     if (Array.isArray(value)) {
       return value.length > 0 ? value.join(', ') : '—';
     }

     // For primitive values, just convert to string
     return value.toString();
   };

 const renderTableRows = () => {
  if (!logData) {
    return (
      <tr>
        <td colSpan="2">No data found.</td>
      </tr>
    );
  }

  const rows = [];

   Object.entries(logData).forEach(([key, value]) => {
     if (key === 'pk' || key === 'log_record_url' || key.toLowerCase().includes('id')) return;

     if (typeof value === 'object' && value !== null && !Array.isArray(value)) {
       Object.entries(value).forEach(([childKey, childVal]) => {
         rows.push(
           <tr key={`${key}.${childKey}`}>
             <td>{formatLabel(`${key} ${childKey}`)}</td>
             <td>{formatValue(childVal)}</td>
           </tr>
         );
       });
     } else {
       rows.push(
         <tr key={key}>
           <td>{formatLabel(key)}</td>
           <td>{formatValue(value)}</td>
         </tr>
       );
     }
   });

 

  return rows;
};
  const handleDownloadSftpLog = (file) => {
    rowLoader(logData?.pk)


    const fileURL = file;

    let alink = document.createElement('a');
    alink.href = fileURL;
    alink.download = 'SamplePDF.pdf';
    alink.target = '_blank';
    alink.click();
    // fetchQueueListing(pageno, limit, searchedData)
  }


  return (
    <Modal show={show} onHide={onClose} size="lg" centered>
      <Modal.Header closeButton>
        <Modal.Title className="d-flex align-items-center justify-content-between ">
          Log Details

          
          <div className="text-end mb-2 fs-7 my-auto ms-2">

            <span onClick={handleCopyTableToClipboard} style={{ cursor: "pointer" }}>
              {copied ? (
                <i className="bi bi-check2-circle text-success me-2"></i>
              ) : (
                <Tooltip disableInteractive title="Copy To Clipboard " placement="top" arrow>
                  <i className="bi bi-clipboard me-2"></i>
                </Tooltip>
              )}
            </span>
            <Tooltip disableInteractive title="Refresh " placement="top" arrow>
              <i onClick={()=>{setReload(prev=>!prev)}} className="bi bi-arrow-clockwise me-2"></i>
            </Tooltip>

          </div>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ maxHeight: '60vh', overflowY: 'auto' }}>
  {loading ? (
    <div className="d-flex justify-content-center align-items-center" style={{ minHeight: 200 }}>
      <Spinner animation="border" />
    </div>
  ) : (
    <>
      <Table bordered hover striped ref={tableRef}>
        <thead style={{ position: 'sticky', top: 0, background: '#f8f9fa', zIndex: 1 }}>
          <tr>
            <th style={{ width: '30%' }}>Field</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>{renderTableRows()}</tbody>
      </Table>

      {logData?.log_record_url && (
        <div className="mt-3 text-end">
          <Button
            variant="primary"
           style={{ backgroundColor: "#6ba2b6", borderColor: "#6ba2b6" }}
            onClick={() => handleDownloadSftpLog(logData.log_record_url)}
          >
            <i className="bi bi-download me-2 text-white"></i>Download Log
          </Button>
        </div>
      )}
    </>
  )}
</Modal.Body>
    </Modal>
  );
};

export default LogDetailsModal;
